import { render } from "./NasTimView.vue?vue&type=template&id=f6532916&scoped=true"
import script from "./NasTimView.vue?vue&type=script&lang=js"
export * from "./NasTimView.vue?vue&type=script&lang=js"

import "./NasTimView.vue?vue&type=style&index=0&id=f6532916&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Development\\saska-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6532916"]])

export default __exports__